module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/js/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(9);


/***/ },
/* 1 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Copyright 2016 Autodesk Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	var molViewUtils = {
	  getBondWidth: function getBondWidth(d) {
	    if (!d || isNaN(parseInt(d.bond, 10))) {
	      throw new Error('Invalid input');
	    }
	    if (d.bond < 0) {
	      throw new Error('d.bond must be at least 0');
	    }
	
	    return d.bond * 4 - 2 + 'px';
	  },
	  chooseColor: function chooseColor(d, defaultValue) {
	    var color = d.category || d.color;
	    if (color) {
	      return color;
	    }
	    return defaultValue;
	  },
	  withDefault: function withDefault(test, defaultValue) {
	    if (typeof test === 'undefined') {
	      return defaultValue;
	    }
	
	    return test;
	  }
	};
	
	exports.default = molViewUtils;

/***/ },
/* 2 */
/***/ function(module, exports) {

	module.exports = require("d3");

/***/ },
/* 3 */
/***/ function(module, exports) {

	module.exports = require("react");

/***/ },
/* 4 */
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d = __webpack_require__(2);
	
	var _mol_view_utils = __webpack_require__(1);
	
	var _mol_view_utils2 = _interopRequireDefault(_mol_view_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(13);
	
	var Links = function (_React$Component) {
	  _inherits(Links, _React$Component);
	
	  function Links() {
	    _classCallCheck(this, Links);
	
	    return _possibleConstructorReturn(this, (Links.__proto__ || Object.getPrototypeOf(Links)).apply(this, arguments));
	  }
	
	  _createClass(Links, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.renderD3();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.renderD3();
	    }
	  }, {
	    key: 'renderD3',
	    value: function renderD3() {
	      if (!this.linksContainer) {
	        return;
	      }
	
	      var container = (0, _d.select)(this.linksContainer);
	
	      var links = container.selectAll('.link').data(this.props.links, function (d) {
	        return d.id;
	      });
	
	      var newLinksG = links.enter().append('g').attr('class', 'link');
	
	      // all edges (includes both bonds and distance constraints)
	      newLinksG.append('line').attr('class', 'link-line');
	      container.selectAll('.link-line').attr('source', function (d) {
	        return typeof d.source.id !== 'undefined' ? d.source.id : d.source;
	      }).attr('target', function (d) {
	        return typeof d.target.id !== 'undefined' ? d.target.id : d.target;
	      }).style('stroke-width', _mol_view_utils2.default.getBondWidth).style('stroke-dasharray', function (d) {
	        if (d.style === 'dashed') {
	          return 5;
	        }
	
	        return 0;
	      }).style('stroke', function (d) {
	        return _mol_view_utils2.default.chooseColor(d, 'black');
	      }).style('opacity', function (d) {
	        if (d.bond !== 0) {
	          return undefined;
	        }
	        return 0.0;
	      });
	
	      // text placeholders for all edges
	      newLinksG.append('text');
	      container.selectAll('.link').selectAll('text').attr('x', function (d) {
	        return d.source.x || 0;
	      }).attr('y', function (d) {
	        return d.source.y || 0;
	      }).attr('text-anchor', 'middle').text(function () {
	        return ' ';
	      });
	
	      // double and triple bonds
	      newLinksG.filter(function (d) {
	        return d.bond > 1;
	      }).append('line').attr('class', 'separator separator-double');
	      container.selectAll('.separator-double').style('stroke', '#FFF').style('stroke-width', function (d) {
	        return d.bond * 4 - 5 + 'px';
	      });
	
	      // triple bonds
	      newLinksG.filter(function (d) {
	        return d.bond === 3;
	      }).append('line').attr('class', 'separator separator-triple');
	      container.selectAll('.separator-triple').style('stroke', function (d) {
	        return _mol_view_utils2.default.chooseColor(d, 'black');
	      }).style('stroke-width', function () {
	        return _mol_view_utils2.default.getBondWidth(1);
	      });
	
	      links.exit().remove();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement('g', { className: 'links-container', ref: function ref(c) {
	          _this2.linksContainer = c;
	        } });
	    }
	  }]);
	
	  return Links;
	}(_react2.default.Component);
	
	Links.propTypes = {
	  links: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object)
	};
	
	exports.default = Links;

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d = __webpack_require__(2);
	
	var _nodes = __webpack_require__(8);
	
	var _nodes2 = _interopRequireDefault(_nodes);
	
	var _links = __webpack_require__(6);
	
	var _links2 = _interopRequireDefault(_links);
	
	var _molecule_utils = __webpack_require__(10);
	
	var _molecule_utils2 = _interopRequireDefault(_molecule_utils);
	
	var _mol_view_utils = __webpack_require__(1);
	
	var _mol_view_utils2 = _interopRequireDefault(_mol_view_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright 2016 Autodesk Inc.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var Molecule2d = function (_React$Component) {
	  _inherits(Molecule2d, _React$Component);
	
	  function Molecule2d(props) {
	    _classCallCheck(this, Molecule2d);
	
	    var _this = _possibleConstructorReturn(this, (Molecule2d.__proto__ || Object.getPrototypeOf(Molecule2d)).call(this, props));
	
	    _this.onClickNode = function (node) {
	      var selectedAtomIds = _this.state.selectedAtomIds.slice(0);
	      var index = selectedAtomIds.indexOf(node.id);
	
	      if (index !== -1) {
	        selectedAtomIds.splice(index, 1);
	      } else {
	        selectedAtomIds.push(node.id);
	      }
	
	      _this.setState({
	        selectedAtomIds: selectedAtomIds
	      });
	
	      _this.props.onChangeSelection(selectedAtomIds);
	    };
	
	    _this.onDragStartedNode = function (d) {
	      if (!_d.event.active) {
	        _this.simulation.alphaTarget(0.3).restart();
	      }
	      d.fx = d.x;
	      d.fy = d.y;
	    };
	
	    _this.onDragEndedNode = function (d) {
	      if (!_d.event.active) {
	        _this.simulation.alphaTarget(0);
	      }
	      d.fx = null;
	      d.fy = null;
	    };
	
	    _this.renderTransform = function () {
	      if (!_this.svg) {
	        return;
	      }
	
	      var container = (0, _d.select)(_this.svg);
	
	      // Nodes
	      container.selectAll('.node').attr('transform', function (d) {
	        return 'translate(' + (d.x || 0) + ',' + (d.y || 0) + ')';
	      });
	
	      // Links
	      var links = container.selectAll('.link');
	
	      // keep edges pinned to their nodes
	      links.selectAll('line').attr('x1', function (d) {
	        return d.source.x || 0;
	      }).attr('y1', function (d) {
	        return d.source.y || 0;
	      }).attr('x2', function (d) {
	        return d.target.x || 0;
	      }).attr('y2', function (d) {
	        return d.target.y || 0;
	      });
	
	      // keep edge labels pinned to the edges
	      links.selectAll('text').attr('x', function (d) {
	        return ((d.source.x || 0) + (d.target.x || 0)) / 2.0;
	      }).attr('y', function (d) {
	        return ((d.source.y || 0) + (d.target.y || 0)) / 2.0;
	      });
	    };
	
	    _this.state = {
	      selectedAtomIds: props.selectedAtomIds || []
	    };
	    return _this;
	  }
	
	  _createClass(Molecule2d, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.renderD3();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!_molecule_utils2.default.compareIds(this.state.selectedAtomIds, nextProps.selectedAtomIds)) {
	        this.setState({
	          selectedAtomIds: nextProps.selectedAtomIds
	        });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.renderD3();
	    }
	  }, {
	    key: 'renderD3',
	    value: function renderD3() {
	      var _this2 = this;
	
	      this.simulation = (0, _d.forceSimulation)().force('link', (0, _d.forceLink)().distance(function (d) {
	        return _mol_view_utils2.default.withDefault(d.distance, 20);
	      }).strength(function (d) {
	        return _mol_view_utils2.default.withDefault(d.strength, 1.0);
	      })).force('charge', (0, _d.forceManyBody)()).force('center', (0, _d.forceCenter)(this.props.width / 2, this.props.height / 2));
	
	      this.simulation.nodes(this.nodes).on('tick', function () {
	        return _this2.renderTransform();
	      });
	
	      this.simulation.force('link').id(function (d) {
	        return d.id;
	      }).links(this.links);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      this.nodes = _molecule_utils2.default.updateModels(this.nodes || [], this.props.modelData.nodes);
	      this.links = _molecule_utils2.default.updateModels(this.links || [], this.props.modelData.links);
	
	      return _react2.default.createElement(
	        'svg',
	        {
	          ref: function ref(c) {
	            _this3.svg = c;
	          },
	          width: this.props.width,
	          height: this.props.height
	        },
	        _react2.default.createElement(_links2.default, {
	          links: this.links
	        }),
	        _react2.default.createElement(_nodes2.default, {
	          selectedAtomIds: this.state.selectedAtomIds,
	          nodes: this.nodes,
	          onClickNode: this.onClickNode,
	          onDragStartedNode: this.onDragStartedNode,
	          onDragEndedNode: this.onDragEndedNode
	        })
	      );
	    }
	  }]);
	
	  return Molecule2d;
	}(_react2.default.Component);
	
	Molecule2d.defaultProps = {
	  width: 500.0,
	  height: 500.0,
	  selectedAtomIds: [],
	  onChangeSelection: function onChangeSelection() {}
	};
	
	Molecule2d.propTypes = {
	  width: _react2.default.PropTypes.number,
	  height: _react2.default.PropTypes.number,
	  modelData: _react2.default.PropTypes.shape({
	    nodes: _react2.default.PropTypes.array,
	    links: _react2.default.PropTypes.array
	  }).isRequired,
	  selectedAtomIds: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.number),
	  onChangeSelection: _react2.default.PropTypes.func
	};
	
	exports.default = Molecule2d;

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d = __webpack_require__(2);
	
	var _mol_view_utils = __webpack_require__(1);
	
	var _mol_view_utils2 = _interopRequireDefault(_mol_view_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(14);
	
	var SELECTED_COLOR = '#39f8ff';
	
	var Nodes = function (_React$Component) {
	  _inherits(Nodes, _React$Component);
	
	  function Nodes() {
	    _classCallCheck(this, Nodes);
	
	    return _possibleConstructorReturn(this, (Nodes.__proto__ || Object.getPrototypeOf(Nodes)).apply(this, arguments));
	  }
	
	  _createClass(Nodes, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.renderD3();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.renderD3();
	    }
	  }, {
	    key: 'renderD3',
	    value: function renderD3() {
	      var _this2 = this;
	
	      if (!this.nodesContainer) {
	        return;
	      }
	
	      var container = (0, _d.select)(this.nodesContainer);
	
	      var nodes = container.selectAll('.node').data(this.props.nodes, function (d) {
	        return d.id;
	      });
	
	      var newNodesG = nodes.enter().append('g');
	
	      newNodesG.attr('class', 'node').on('click', this.props.onClickNode).attr('index', function (d) {
	        return d.id;
	      }).call((0, _d.drag)().on('start', this.props.onDragStartedNode).on('drag', Nodes.onDragged).on('end', this.props.onDragEndedNode));
	
	      container.selectAll('.node').classed('selected', function (d) {
	        return _this2.props.selectedAtomIds.indexOf(d.id) !== -1 ? SELECTED_COLOR : '';
	      });
	
	      var radius = (0, _d.scaleSqrt)().range([0, 6]);
	
	      // circle for each atom (background color white by default)
	      newNodesG.append('circle').attr('class', 'atom-circle').attr('r', function (d) {
	        return radius(_mol_view_utils2.default.withDefault(d.size, 1.5));
	      }).style('fill', function (d) {
	        return _mol_view_utils2.default.chooseColor(d, 'white');
	      });
	      (0, _d.selectAll)('.atom-circle').style('stroke', function (d) {
	        return _this2.props.selectedAtomIds.indexOf(d.id) !== -1 ? SELECTED_COLOR : '';
	      });
	
	      // atom labels
	      newNodesG.append('text').attr('class', 'atom-label').attr('dy', '.35em').attr('text-anchor', 'middle').text(function (d) {
	        return d.atom;
	      });
	      container.selectAll('.atom-label').attr('fill', function (d) {
	        var color = _this2.props.selectedAtomIds.indexOf(d.id) !== -1 ? SELECTED_COLOR : '';
	        return _mol_view_utils2.default.withDefault(d.textcolor, color);
	      });
	
	      nodes.exit().remove();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement('g', { className: 'nodes-container', ref: function ref(c) {
	          _this3.nodesContainer = c;
	        } });
	    }
	  }], [{
	    key: 'onDragged',
	    value: function onDragged(d) {
	      d.fx = _d.event.x;
	      d.fy = _d.event.y;
	    }
	  }]);
	
	  return Nodes;
	}(_react2.default.Component);
	
	Nodes.propTypes = {
	  selectedAtomIds: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.number),
	  nodes: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
	  onClickNode: _react2.default.PropTypes.func,
	  onDragStartedNode: _react2.default.PropTypes.func,
	  onDragEndedNode: _react2.default.PropTypes.func
	};
	
	exports.default = Nodes;

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _molecule_2d = __webpack_require__(7);
	
	var _molecule_2d2 = _interopRequireDefault(_molecule_2d);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _molecule_2d2.default; /**
	                                          * Copyright 2016 Autodesk Inc.
	                                          *
	                                          * Licensed under the Apache License, Version 2.0 (the "License");
	                                          * you may not use this file except in compliance with the License.
	                                          * You may obtain a copy of the License at
	                                          *
	                                          *     http://www.apache.org/licenses/LICENSE-2.0
	                                          *
	                                          * Unless required by applicable law or agreed to in writing, software
	                                          * distributed under the License is distributed on an "AS IS" BASIS,
	                                          * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                          * See the License for the specific language governing permissions and
	                                          * limitations under the License.
	                                          */

/***/ },
/* 10 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var moleculeUtils = {
	  /**
	   * Given two arrays of ids, return true if they contain the same values in any order,
	   * ignoring duplicates
	   * @param idsA {Array}
	   * @param idsB {Array}
	   * @returns {Boolean}
	   */
	  compareIds: function compareIds(idsA, idsB) {
	    // If one array is empty and the other isn't, they can't contain the same values
	    if (!idsA.length && idsB.length || idsA.length && !idsB.length) {
	      return false;
	    }
	
	    var mapA = new Map();
	    idsA.forEach(function (id) {
	      mapA.set(id, false);
	    });
	
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = idsB[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var id = _step.value;
	
	        // If an id exists in B but not in A, not equivalent
	        if (!mapA.has(id)) {
	          return false;
	        }
	        mapA.set(id, true);
	      }
	
	      // If an id exists in A but not B, not equivalent
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	
	    var _iteratorNormalCompletion2 = true;
	    var _didIteratorError2 = false;
	    var _iteratorError2 = undefined;
	
	    try {
	      for (var _iterator2 = mapA[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	        var tuple = _step2.value;
	
	        var value = tuple[1];
	        if (!value) {
	          return false;
	        }
	      }
	    } catch (err) {
	      _didIteratorError2 = true;
	      _iteratorError2 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion2 && _iterator2.return) {
	          _iterator2.return();
	        }
	      } finally {
	        if (_didIteratorError2) {
	          throw _iteratorError2;
	        }
	      }
	    }
	
	    return true;
	  },
	
	
	  /**
	   * Due to craziness of D3, we need to keep our main modelData state as the same object and mutate
	   * it in place.  The same goes for all sub-objects within modelData.
	   * @param oldModelData {Object}
	   * @param newModelData {Object}
	   * @returns {Object}
	   */
	  updateObjectInPlace: function updateObjectInPlace(oldObject, newObject) {
	    Object.keys(newObject).forEach(function (key) {
	      if (oldObject[key] instanceof Object && newObject[key] instanceof Object) {
	        oldObject[key] = moleculeUtils.updateObjectInPlace(oldObject[key], newObject[key]);
	      } else {
	        oldObject[key] = newObject[key];
	      }
	    });
	
	    return oldObject;
	  },
	
	
	  /**
	   * Given old and new arrays of models, update the old array's models in place based on id
	   * If model ids don't perfectly match, just return newArray
	   * O(n^2) :(
	   * @param oldArray {Array}
	   * @param newArray {Array}
	   * @returns {Array}
	   */
	  updateModels: function updateModels(oldArray, newArray) {
	    var sameIds = moleculeUtils.compareIds(oldArray.map(function (model) {
	      return model.id;
	    }), newArray.map(function (model) {
	      return model.id;
	    }));
	    if (!sameIds) {
	      return newArray;
	    }
	
	    // Add or update everything in newArray to oldArray
	    newArray.forEach(function (newModel) {
	      var found = false;
	      for (var i = 0; i < oldArray.length; i += 1) {
	        if (oldArray[i].id === newModel.id) {
	          oldArray[i] = moleculeUtils.updateObjectInPlace(oldArray[i], newModel);
	          found = true;
	          break;
	        }
	      }
	
	      if (!found) {
	        oldArray.push(newModel);
	      }
	    });
	
	    // Remove els in oldArray that don't exist in newArray
	
	    var _loop = function _loop(_i) {
	      var oldModel = oldArray[_i];
	      var newModel = newArray.find(function (newModelI) {
	        return newModelI.id === oldModel.id;
	      });
	
	      if (!newModel) {
	        oldArray.splice(_i, 1);
	        _i -= 1;
	      }
	      i = _i;
	    };
	
	    for (var i = 0; i < oldArray.length; i += 1) {
	      _loop(i);
	    }
	
	    return oldArray;
	  }
	};
	
	exports.default = moleculeUtils;

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(4)();
	// imports
	
	
	// module
	exports.push([module.id, ".link line{stroke:#696969}.link line.separator{stroke:#fff;stroke-width:2px}", ""]);
	
	// exports


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(4)();
	// imports
	
	
	// module
	exports.push([module.id, ".node text{font:10px sans-serif;pointer-events:none}", ""]);
	
	// exports


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(11);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(5)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../node_modules/css-loader/index.js!./../../node_modules/sass-loader/index.js!./links.scss", function() {
				var newContent = require("!!./../../node_modules/css-loader/index.js!./../../node_modules/sass-loader/index.js!./links.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(12);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(5)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../node_modules/css-loader/index.js!./../../node_modules/sass-loader/index.js!./nodes.scss", function() {
				var newContent = require("!!./../../node_modules/css-loader/index.js!./../../node_modules/sass-loader/index.js!./nodes.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }
/******/ ]);


// WEBPACK FOOTER //
// bundle.js